export default function Requisites() {
  return (
    <div className="prose prose-sm max-w-none">
      <h1 className="text-2xl font-bold mb-6 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
        Реквизиты
      </h1>

      <div className="space-y-6">
        {/*<section className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl p-6">*/}
        {/*  <h2 className="text-xl font-semibold text-gray-900 mb-4">*/}
        {/*    Индивидуальный предприниматель*/}
        {/*  </h2>*/}

        {/*  <div className="space-y-3">*/}
        {/*    <div className="flex items-start">*/}
        {/*      <span className="font-medium text-gray-600 w-32 flex-shrink-0">*/}
        {/*        ФИО:*/}
        {/*      </span>*/}
        {/*      <span className="text-gray-900">*/}
        {/*        Макарова Наталья Анатольевна*/}
        {/*      </span>*/}
        {/*    </div>*/}

        {/*    <div className="flex items-start">*/}
        {/*      <span className="font-medium text-gray-600 w-32 flex-shrink-0">*/}
        {/*        ИНН:*/}
        {/*      </span>*/}
        {/*      <span className="text-gray-900 font-mono">594489465119</span>*/}
        {/*    </div>*/}

        {/*    <div className="flex items-start">*/}
        {/*      <span className="font-medium text-gray-600 w-32 flex-shrink-0">*/}
        {/*        Телефон:*/}
        {/*      </span>*/}
        {/*      <a*/}
        {/*        href="tel:+79026403248"*/}
        {/*        className="text-purple-600 hover:underline"*/}
        {/*      >*/}
        {/*        +7 (902) 640-32-48*/}
        {/*      </a>*/}
        {/*    </div>*/}

        {/*    <div className="flex items-start">*/}
        {/*      <span className="font-medium text-gray-600 w-32 flex-shrink-0">*/}
        {/*        E-mail:*/}
        {/*      </span>*/}
        {/*      <a*/}
        {/*        href="mailto:sup_musiccreator@mail.ru"*/}
        {/*        className="text-purple-600 hover:underline"*/}
        {/*      >*/}
        {/*        sup_musiccreator@mail.ru*/}
        {/*      </a>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</section>*/}

        <section className="bg-white rounded-2xl p-6 border border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Контактная информация
          </h2>

          <div className="space-y-3 text-gray-700">
            <p>
              По всем вопросам, связанным с работой сервиса, оплатой услуг или
              технической поддержкой, вы можете связаться с нами любым удобным
              способом:
            </p>

            <ul className="list-disc pl-6 space-y-2">
              <li>
                Электронная почта:{' '}
                <a
                  href="mailto:sup_musiccreator@mail.ru"
                  className="text-purple-600 hover:underline"
                >
                  sup_musiccreator@mail.ru
                </a>
              </li>
              {/*<li>*/}
              {/*  Телефон:{' '}*/}
              {/*  <a*/}
              {/*    href="tel:+79026403248"*/}
              {/*    className="text-purple-600 hover:underline"*/}
              {/*  >*/}
              {/*    +7 (902) 640-32-48*/}
              {/*  </a>*/}
              {/*</li>*/}
            </ul>

            <p className="text-sm text-gray-600 mt-4">
              Мы стремимся отвечать на все обращения в течение 24 часов в
              рабочие дни.
            </p>
          </div>
        </section>

        <section className="bg-blue-50 rounded-2xl p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Юридическая информация
          </h2>

          <div className="text-gray-700 space-y-2">
            <p>
              Все услуги предоставляются в соответствии с законодательством
              Российской Федерации.
            </p>
            <p>
              Оплата услуг производится в соответствии с{' '}
              <button className="text-purple-600 hover:underline font-medium">
                Публичной офертой
              </button>
              .
            </p>
            <p>
              Персональные данные обрабатываются в соответствии с{' '}
              <button className="text-purple-600 hover:underline font-medium">
                Политикой конфиденциальности
              </button>
              .
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
